.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.toolbar {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

/* The list scrolls inside the dialog, so the search stays in view. */
.rows {
  max-height: min(26rem, 55vh);
  margin: 0 calc(-1 * var(--space-5));
  padding: 0;
  overflow-y: auto;
  list-style: none;
  border-top: 1px solid var(--color-border);
  border-bottom: 1px solid var(--color-border);
}

.last {
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
}

.more {
  margin: 0;
  font-size: var(--font-size-sm);
  color: var(--color-text-muted);
}
